import React, { useMemo, useState } from "react";


const evidenceItems =
[
    {
        id: 1,

        sourceType:
            "DOCUMENT",

        title:
            "Fire Risk Assessment.pdf",

        page:
            17,

        section:
            "Means of Escape",

        text:
            "Fire doors serving protected escape routes shall remain "
            + "unobstructed and capable of closing fully at all times.",

        relevance:
            98
    },
    {
        id: 2,

        sourceType:
            "INSPECTION",

        title:
            "Weekly Fire Door Inspection.xlsx",

        page:
            4,

        section:
            "Door FD-17",

        text:
            "Fire door FD-17 failed its operational inspection due "
            + "to a damaged self-closing mechanism.",

        relevance:
            96
    },
    {
        id: 3,

        sourceType:
            "MAINTENANCE",

        title:
            "Reactive Maintenance Report.pdf",

        page:
            9,

        section:
            "Corrective Works",

        text:
            "Replacement of the door closer is recommended within "
            + "14 days to restore compliant operation.",

        relevance:
            92
    },
    {
        id: 4,

        sourceType:
            "AUDIT",

        title:
            "Building Compliance Audit.pdf",

        page:
            31,

        section:
            "Fire Safety Findings",

        text:
            "The inspection identified stored materials affecting "
            + "access to several protected escape routes.",

        relevance:
            89
    },
    {
        id: 5,

        sourceType:
            "GUIDANCE",

        title:
            "Fire Safety Management Procedure.pdf",

        page:
            12,

        section:
            "Inspection Requirements",

        text:
            "Defects affecting fire doors must be reported promptly "
            + "and prioritised for remedial action.",

        relevance:
            84
    }
];


function getSourceLabel(
    sourceType)
{
    switch (sourceType)
    {
        case "INSPECTION":
            return "Inspection";

        case "MAINTENANCE":
            return "Maintenance";

        case "AUDIT":
            return "Audit";

        case "GUIDANCE":
            return "Guidance";

        default:
            return "Document";
    }
}


function getSourceColour(
    sourceType)
{
    switch (sourceType)
    {
        case "INSPECTION":
            return "#38bdf8";

        case "MAINTENANCE":
            return "#f59e0b";

        case "AUDIT":
            return "#a78bfa";

        case "GUIDANCE":
            return "#22c55e";

        default:
            return "#60a5fa";
    }
}


export default function WorkspaceEvidenceList(
{
    insight,
    onEvidenceSelected
})
{
    const [search,
        setSearch] =
        useState("");


    const [selectedEvidenceId,
        setSelectedEvidenceId] =
        useState(null);


    const filteredEvidence =
        useMemo(
            function ()
            {
                const searchValue =
                    search
                        .trim()
                        .toLowerCase();

                if (!searchValue)
                {
                    return evidenceItems;
                }

                return evidenceItems.filter(
                    function (
                        evidence)
                    {
                        return (
                            evidence.title
                                .toLowerCase()
                                .includes(searchValue)
                            ||
                            evidence.section
                                .toLowerCase()
                                .includes(searchValue)
                            ||
                            evidence.text
                                .toLowerCase()
                                .includes(searchValue)
                            ||
                            evidence.sourceType
                                .toLowerCase()
                                .includes(searchValue)
                        );
                    }
                );
            },
            [
                search
            ]
        );


    const selectEvidence =
        function (
            evidence)
        {
            setSelectedEvidenceId(
                evidence.id);

            if (onEvidenceSelected)
            {
                onEvidenceSelected(
                    evidence);
            }
        };


    return (

        <div
            style={{
                width:
                    "100%",

                height:
                    "100%",

                minHeight:
                    0,

                display:
                    "flex",

                flexDirection:
                    "column",

					background: "#f7f8fa",

					color: "#1f2937"
            }}
        >

            {/*==================================================
                CONTEXT
            ==================================================*/}

            <div
                style={{
                    padding:
                        "18px 18px 14px",

						borderBottom:
						    "1px solid #e5e7eb"
                }}
            >

                <div
                    style={{
                        marginBottom:
                            "5px",

                        color:"#1f2937",

                        fontSize:
                            "14px",

                        fontWeight:
                            700,

                        lineHeight:
                            "1.35"
                    }}
                >
                    {
                        insight?.title
                        ?? "Fire Door Inspection Overdue"
                    }
                </div>

                <div
                    style={{
                       
                            color:"#6b7280",

                        fontSize:
                            "12px",

                        lineHeight:
                            "1.5"
                    }}
                >
                    Documents and extracted snippets supporting this
                    investigation.
                </div>

            </div>


            {/*==================================================
                SEARCH
            ==================================================*/}

            <div
                style={{
                    padding:
                        "16px 18px 12px"
                }}
            >

                <input
                    type="text"

                    value={search}

                    placeholder=
                        "Search evidence..."

                    onChange={
                        function (
                            event)
                        {
                            setSearch(
                                event.target.value);
                        }
                    }

                    style={{
                        boxSizing:
                            "border-box",

                        width:
                            "100%",

                        padding:
                            "11px 13px",

							border:
							    "1px solid #d7dde6",

                        borderRadius:
                            "10px",

                        outline:
                            "none",

							background:
							    "#ffffff",

							color:
							    "#1f2937",

                        fontSize:
                            "13px",
							boxShadow:
							    "0 2px 8px rgba(0,0,0,.05)"
                    }}
                />

            </div>


            {/*==================================================
                RESULT COUNT
            ==================================================*/}

            <div
                style={{
                    padding:
                        "0 20px 12px",

                 
                        color:"#6b7280",

                    fontSize:
                        "11px",

                    fontWeight:
                        700,

                    letterSpacing:
                        ".75px",

                    textTransform:
                        "uppercase"
                }}
            >
                {
                    filteredEvidence.length
                }
                {
                    filteredEvidence.length === 1
                        ? " Evidence Source"
                        : " Evidence Sources"
                }
            </div>


            {/*==================================================
                EVIDENCE LIST
            ==================================================*/}

            <div
                style={{
                    flex:
                        1,

                    minHeight:
                        0,

                    overflowY:
                        "auto",

                    overflowX:
                        "hidden",

                    padding:
                        "0 12px 20px"
                }}
            >

                {
                    filteredEvidence.map(
                        function (
                            evidence)
                        {
                            const selected =
                                selectedEvidenceId
                                === evidence.id;

                            const sourceColour =
                                getSourceColour(
                                    evidence.sourceType);

                            return (

                                <div
                                    key={evidence.id}

                                    onClick={
                                        function ()
                                        {
                                            selectEvidence(
                                                evidence);
                                        }
                                    }

                                    style={{
                                        position:
                                            "relative",

                                        marginBottom:
                                            "11px",

                                        padding:
                                            "15px",

                                        overflow:
                                            "hidden",

											border:
											    selected
											        ? "1px solid #5a9bd6"
											        : "1px solid #e5e7eb",

											background:
											    selected
											        ? "#eef6fd"
											        : "#ffffff",

											boxShadow:
											    "0 6px 18px rgba(0,0,0,.06)",

                                        borderRadius:
                                            "14px",

                                        cursor:
                                            "pointer",

                                        transition:
                                            "background .18s ease, "
                                            + "border-color .18s ease, "
                                            + "box-shadow .18s ease, "
                                            + "transform .18s ease"
                                    }}

                                    onMouseEnter={
                                        function (
                                            event)
                                        {
                                            event
                                                .currentTarget
                                                .style
                                                .transform =
                                                "translateY(-2px)";

                                            event
                                                .currentTarget
                                                .style
                                                .boxShadow =
                                                "0 13px 30px rgba(0,0,0,.28)";
                                        }
                                    }

                                    onMouseLeave={
                                        function (
                                            event)
                                        {
                                            event
                                                .currentTarget
                                                .style
                                                .transform =
                                                "translateY(0)";

                                            event
                                                .currentTarget
                                                .style
                                                .boxShadow =
                                                selected
                                                    ? "0 12px 28px rgba(0,0,0,.28)"
                                                    : "0 7px 18px rgba(0,0,0,.16)";
                                        }
                                    }
                                >

                                    {/* SOURCE ACCENT */}

                                    <div
                                        style={{
                                            position:
                                                "absolute",

                                            top:
                                                0,

                                            bottom:
                                                0,

                                            left:
                                                0,

                                            width:
                                                "4px",

                                            background:
                                                sourceColour
                                        }}
                                    />


                                    {/* SOURCE TYPE */}

                                    <div
                                        style={{
                                            display:
                                                "flex",

                                            alignItems:
                                                "center",

                                            justifyContent:
                                                "space-between",

                                            gap:
                                                "12px",

                                            marginBottom:
                                                "9px"
                                        }}
                                    >

                                        <span
                                            style={{
                                                display:
                                                    "inline-flex",

                                                alignItems:
                                                    "center",

                                                padding:
                                                    "4px 8px",

                                                borderRadius:
                                                    "7px",

                                                background:
                                                    sourceColour
                                                    + "22",

                                                color:
                                                    sourceColour,

                                                fontSize:
                                                    "9px",

                                                fontWeight:
                                                    800,

                                                letterSpacing:
                                                    ".65px",

                                                textTransform:
                                                    "uppercase"
                                            }}
                                        >
                                            {
                                                getSourceLabel(
                                                    evidence.sourceType)
                                            }
                                        </span>


                                        <span
                                            style={{
                                                color:
                                                    "#94a3b8",

                                                fontSize:
                                                    "10px",

                                                fontWeight:
                                                    600
                                            }}
                                        >
                                            {
                                                evidence.relevance
                                            }
                                            % match
                                        </span>

                                    </div>


                                    {/* DOCUMENT */}

                                    <div
                                        style={{
                                            marginBottom:
                                                "4px",

                                            color:
                                                "#1f2937",

                                            fontSize:
                                                "14px",

                                            fontWeight:
                                                700,

                                            lineHeight:
                                                "1.35"
                                        }}
                                    >
                                        {
                                            evidence.title
                                        }
                                    </div>


                                    {/* PAGE / SECTION */}

                                    <div
                                        style={{
                                            marginBottom:
                                                "10px",

                                            color:
                                                "#6b7280",

                                            fontSize:
                                                "11px"
                                        }}
                                    >
                                        Page {
                                            evidence.page
                                        }
                                        {
                                            evidence.section
                                                ? " • "
                                                + evidence.section
                                                : ""
                                        }
                                    </div>


                                    {/* SNIPPET */}

                                    <div
                                        style={{
                                            marginBottom:
                                                "12px",

                                            color:
                                                "#4b5563",

                                            fontSize:
                                                "12px",

                                            lineHeight:
                                                "1.65"
                                        }}
                                    >
                                        “{
                                            evidence.text
                                        }”
                                    </div>


                                    {/* OPEN SOURCE */}

                                    <button
                                        type="button"

                                        onClick={
                                            function (
                                                event)
                                            {
                                                event
                                                    .stopPropagation();

                                                selectEvidence(
                                                    evidence);
                                            }
                                        }

                                        style={{
                                            width:
                                                "100%",

                                            height:
                                                "35px",

                                           

                                            borderRadius:
                                                "9px",

												background:
												    "#ffffff",

												border:
												    "1px solid #d9dee7",

												color:
												    "#374151",

                                            fontSize:
                                                "11px",

                                            fontWeight:
                                                700,

                                            cursor:
                                                "pointer"
                                        }}
                                    >
                                        Open Source
                                    </button>

                                </div>

                            );
                        }
                    )
                }


                {
                    filteredEvidence.length === 0
                    &&
                    (
                        <div
                            style={{
                                padding:
                                    "48px 20px",

                                color:
                                    "#94a3b8",

                                fontSize:
                                    "13px",

                                lineHeight:
                                    "1.6",

                                textAlign:
                                    "center"
                            }}
                        >
                            No supporting evidence matches your search.
                        </div>
                    )
                }

            </div>

        </div>

    );
}